module.exports = __webpack_public_path__ + "static/media/chooseAnotherWayToPay.5e82c095.png";